import { useStorePubSub } from 'drycut-apollo';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  slug: string;
}>;

export default function StorePubSubWrapper({ slug, children }: Props): JSX.Element {
  // Real time updates for the waiting time and stylist list.
  useStorePubSub({ slug });

  return <div id="store-pubsub-wrapper">{children}</div>;
}
